import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "el-form-item__content" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group d-flex flex-wrap" }
const _hoisted_13 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group d-flex flex-wrap" }
const _hoisted_16 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group d-flex flex-wrap" }
const _hoisted_19 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group d-flex flex-wrap" }
const _hoisted_24 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group d-flex flex-wrap" }
const _hoisted_27 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group d-flex flex-wrap" }
const _hoisted_30 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group d-flex flex-wrap" }
const _hoisted_33 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "form-group d-flex flex-wrap" }
const _hoisted_38 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "form-group d-flex flex-wrap" }
const _hoisted_41 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "form-group d-flex flex-wrap" }
const _hoisted_44 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = { class: "form-group d-flex flex-wrap" }
const _hoisted_47 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_48 = { class: "col-md-6" }
const _hoisted_49 = { class: "form-group d-flex flex-wrap" }
const _hoisted_50 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "form-group d-flex flex-wrap" }
const _hoisted_53 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { class: "form-group d-flex flex-wrap" }
const _hoisted_56 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_57 = { class: "col-md-6" }
const _hoisted_58 = { class: "form-group d-flex flex-wrap" }
const _hoisted_59 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = { class: "form-group d-flex flex-wrap" }
const _hoisted_64 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_65 = { class: "col-md-6" }
const _hoisted_66 = { class: "form-group d-flex flex-wrap" }
const _hoisted_67 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_68 = { class: "mb-7" }
const _hoisted_69 = { class: "table-responsive" }
const _hoisted_70 = { class: "table align-middle table-row-bordered table-rounded border fs-6 gy-3 gs-3 mb-0" }
const _hoisted_71 = { class: "text-start text-gray-400 fw-bold fs-7 text-uppercase" }
const _hoisted_72 = {
  colspan: "1",
  rowspan: "1",
  class: "text-start"
}
const _hoisted_73 = {
  colspan: "1",
  rowspan: "1",
  class: "text-start"
}
const _hoisted_74 = { class: "fw-bold text-gray-800" }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column justify-content-center align-items-center h-60px" }, " No data found ")
], -1)
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = { class: "d-flex flex-row align-items-center mb-5" }
const _hoisted_79 = { class: "mb-0" }
const _hoisted_80 = { class: "svg-icon svg-icon-3 mx-0 svg-icon-primary" }
const _hoisted_81 = { class: "row mb-7 mx-0" }
const _hoisted_82 = { class: "svg-icon svg-icon-3" }
const _hoisted_83 = ["onClick"]
const _hoisted_84 = { class: "svg-icon svg-icon-3" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_86 = { class: "row" }
const _hoisted_87 = { class: "col-md-6" }
const _hoisted_88 = { class: "form-group d-flex flex-wrap" }
const _hoisted_89 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_90 = { class: "col-md-6" }
const _hoisted_91 = { class: "form-group d-flex flex-wrap" }
const _hoisted_92 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_93 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_95 = { class: "svg-icon svg-icon-2" }
const _hoisted_96 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_97 = { class: "indicator-label" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_99 = { class: "indicator-progress" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_CommonProduct = _resolveComponent("CommonProduct")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_AddQualityInspection = _resolveComponent("AddQualityInspection")!
  const _component_FsLightbox = _resolveComponent("FsLightbox")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      onSubmit: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      rules: _ctx.rules,
      model: _ctx.formData,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("common.information")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("stockIn.status")), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", _ctx.getStatusHtml(_ctx.formData.status)])
                    }, _toDisplayString(_ctx.formData.__show.status), 3)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("stockIn.id")), 1),
                  _createVNode(_component_el_form_item, { prop: "stock_in_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.stock_in_id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.stock_in_id) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("stockIn.taskOwner")), 1),
                  _createVNode(_component_el_form_item, { prop: "created_uid" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.created_uid,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.created_uid) = $event)),
                        filterable: "",
                        clearable: "",
                        "remote-show-suffix": "",
                        remote: "",
                        "remote-method": _ctx.searchTaskOwnerItems,
                        style: {"width":"100%"},
                        disabled: "",
                        placeholder: " "
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.created_uid, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "remote-method"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("stockIn.warehouse")), 1),
                  _createVNode(_component_el_form_item, { prop: "warehouse_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.warehouse_id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.warehouse_id) = $event)),
                        clearable: "",
                        style: {"width":"100%"},
                        disabled: "",
                        placeholder: " "
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.warehouse, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.t("stockIn.shipmentSource")), 1),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("stockIn.trackingNo")), 1),
                  _createVNode(_component_el_form_item, { prop: "tracking_no" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.tracking_no,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.tracking_no) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.t("stockIn.fulfillmentOrderNo")), 1),
                  _createVNode(_component_el_form_item, { prop: "fulfillment_order_number" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.fulfillment_order_number,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.fulfillment_order_number) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: "",
                        disabled: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("stockIn.consigner")), 1),
                  _createVNode(_component_el_form_item, { prop: "fulfillment_order_number" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.consigner,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.options.consigner) = $event)),
                        type: "textarea",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: "",
                        disabled: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.t("stockIn.receivedDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "received_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.received_date,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.received_date) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.t("stockIn.skuVerification")), 1),
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.t("order.skuGtin")), 1),
                  _createVNode(_component_el_form_item, { prop: "sku_info.sku_gtin" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.sku_info.sku_gtin,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.sku_info.sku_gtin) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.t("order.merchantArticleNo")), 1),
                  _createVNode(_component_el_form_item, { prop: "sku_info.merchant_article_no" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.sku_info.merchant_article_no,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.sku_info.merchant_article_no) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.t("order.color")), 1),
                  _createVNode(_component_el_form_item, { prop: "sku_info.color" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.sku_info.color,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.sku_info.color) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.t("order.size")), 1),
                  _createVNode(_component_el_form_item, { prop: "sku_info.size" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.sku_info.size,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.sku_info.size) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.t("stockIn.demandQuantity")), 1),
                  _createVNode(_component_el_form_item, { prop: "sku_info.received_quantity" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.sku_info.received_quantity,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.sku_info.received_quantity) = $event)),
                        type: "number",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.t("stockIn.passedQuantity")), 1),
                  _createVNode(_component_el_form_item, { prop: "sku_info.passed_quantity" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.sku_info.passed_quantity,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.sku_info.passed_quantity) = $event)),
                        type: "number",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.t("stockIn.failedQuantity")), 1),
                  _createVNode(_component_el_form_item, { prop: "sku_info.failed_quantity" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.sku_info.failed_quantity,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.sku_info.failed_quantity) = $event)),
                        type: "number",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.t("order.countryOfOrigin")), 1),
                  _createVNode(_component_el_form_item, { prop: "sku_info.origin_country" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        class: "w-100",
                        modelValue: _ctx.formData.sku_info.origin_country,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.sku_info.origin_country) = $event)),
                        filterable: "",
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.origin_country, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.value + '(' + item.label + ')',
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.t("stockIn.skuIdentification")), 1),
            _hoisted_60,
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.t("order.skuIdentifier")), 1),
                  _createVNode(_component_el_form_item, { prop: "sku_info.sku_identifier" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.sku_info.sku_identifier,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.sku_info.sku_identifier) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.t("order.spuNumber")), 1),
                  _createVNode(_component_el_form_item, { prop: "sku_info.spu" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.sku_info.spu,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.sku_info.spu) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("table", _hoisted_70, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_71, [
                      _createElementVNode("th", _hoisted_72, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.t("order.product")), 1)
                      ]),
                      _createElementVNode("th", _hoisted_73, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.t("order.sku")), 1)
                      ])
                    ])
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("tbody", _hoisted_74, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.product_items, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        (_openBlock(), _createBlock(_component_CommonProduct, {
                          gallery: item.gallery,
                          brand_id: item.__show.brand_id,
                          brand_article_no: item.brand_article_no,
                          product_identifier_id: item.product_identifier_id,
                          source_link: item.source_link,
                          name: item.name,
                          name_en: item.name_en,
                          color: item.__show.color,
                          size: item.__show.size,
                          key: index
                        }, null, 8, ["gallery", "brand_id", "brand_article_no", "product_identifier_id", "source_link", "name", "name_en", "color", "size"]))
                      ]))
                    }), 128)),
                    (_ctx.options.product_items.length == 0)
                      ? _withDirectives((_openBlock(), _createElementBlock("tr", _hoisted_75, _hoisted_77)), [
                          [_directive_loading, _ctx.loading]
                        ])
                      : _createCommentVNode("", true)
                  ])), [
                    [_directive_loading, _ctx.options.loadingProducts]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("h3", _hoisted_79, _toDisplayString(_ctx.t("stockIn.qualityInspection")), 1),
              _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                class: "btn btn-sm ms-3 btn-link p-2 border border-white d-flex",
                title: "Add",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.handleAddQualityInspection && _ctx.handleAddQualityInspection(...args)))
              }, [
                _createElementVNode("span", _hoisted_80, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                ])
              ])), [
                [_directive_auth, { auth: ['update'] }]
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createVNode(_component_el_table, {
                class: "w-100 p-0",
                data: _ctx.formData.quality_inspection,
                "summary-method": _ctx.getSummaries,
                "show-summary": "",
                size: "small",
                "min-width": "220"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('order.skuIdentifier'),
                    prop: "sku_identifier"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('order.spuNumber')
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('inspectionReport.checkPoint'),
                    prop: "check_point"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('inspectionReport.result'),
                    prop: "__show.inspection_status"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('inspectionReport.inspectionNotes'),
                    prop: "inspection_notes"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('common.images'),
                    width: "150"
                  }, {
                    default: _withCtx(({ row }) => [
                      (row.images.length > 0)
                        ? (_openBlock(), _createBlock(_component_el_carousel, {
                            key: 0,
                            "indicator-position": "none",
                            height: "100px",
                            autoplay: false,
                            arrow: "always"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.images, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                  key: index,
                                  class: "d-flex justify-content-center align-items-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_image, {
                                      style: {"width":"100px","height":"100px"},
                                      src: item,
                                      fit: "contain"
                                    }, null, 8, ["src"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, { label: "" }, {
                    default: _withCtx(({ row, $index }) => [
                      _createVNode(_component_router_link, {
                        to: '/documents/inspection-report/' + row.id + '/edit',
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_82, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _withDirectives((_openBlock(), _createElementBlock("button", {
                        type: "button",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                        onClick: ($event: any) => (_ctx.handleDeleteQualityInspection($index, row))
                      }, [
                        _createElementVNode("span", _hoisted_84, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                        ])
                      ], 8, _hoisted_83)), [
                        [_directive_auth, { auth: ['update'] }]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "summary-method"])
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.t("stockIn.inventoryStockIn")), 1),
            _hoisted_85,
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.t("stockIn.inventoryTarget")), 1),
                  _createVNode(_component_el_form_item, { prop: "inventory_target" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.inventory_target,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.inventory_target) = $event)),
                        clearable: "",
                        style: {"width":"100%"},
                        disabled: "",
                        placeholder: " "
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.inventory_target, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.t("stockIn.stockInQuantity")), 1),
                  _createVNode(_component_el_form_item, { prop: "stock_in_quantity" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.stock_in_quantity,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.stock_in_quantity) = $event)),
                        type: "number",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary align-self-center me-2",
              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
            }, [
              _hoisted_94,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
            ]),
            _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["btn btn-success me-2", { disabled: _ctx.options.statusLoading || _ctx.loading }]),
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.handleEntryStockIn && _ctx.handleEntryStockIn(...args)))
                }, [
                  _createElementVNode("span", _hoisted_95, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr042.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("stockIn.stockIn")), 1)
                ], 2), [
                  [_vShow, _ctx.formData.status == '70' && !_ctx.options.readyLoading]
                ]),
                _createElementVNode("button", _hoisted_96, [
                  _createElementVNode("span", _hoisted_97, [
                    _hoisted_98,
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                  ]),
                  _createElementVNode("span", _hoisted_99, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                    _hoisted_100
                  ])
                ], 512)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["rules", "model"]),
    _createVNode(_component_AddQualityInspection, {
      id: _ctx.parentQualityInspectionId,
      "parent-id": Number(_ctx.$route.params.id),
      onUpdateList: _cache[23] || (_cache[23] = ($event: any) => (_ctx.getShowInfo(true))),
      onResetForm: _ctx.handleAddQualityInspection
    }, null, 8, ["id", "parent-id", "onResetForm"]),
    _createVNode(_component_FsLightbox, {
      toggler: _ctx.options.toggler,
      sources: _ctx.options.sources,
      slide: _ctx.options.sourcesSlide
    }, null, 8, ["toggler", "sources", "slide"])
  ], 64))
}